import React, {useEffect, useState} from "react";
import {useParams} from "react-router";
import Navbar from "../Navbar/Navbar";
import SideMenu from "./SideMenu";
import {useQuery} from "@tanstack/react-query";
import {ArticleModel, PreOrderDetailsModel} from "@/api/Models";
import LoadingElement from "../Loading/LoadingElement";

import {
    Table,
    TableBody,
    TableCaption,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table"
import {fetchPreOrder, PreOrderDetailsListResponse} from "@/api/PreOrdersAPI";
import {toast} from "../ui/use-toast";
import ApiHttpClient from "@/HttpClient";

function MyPreOrderDetails() {
    const queryParams = useParams();
    const preOrderId = queryParams.preOrderId;
    const [currentPage, setCurrentPage] = useState(0);
    const [inputValue, setInputValue] = useState(currentPage + 1);
    const [debounceTimer, setDebounceTimer] = useState<NodeJS.Timeout | null>(null);
    const [dataPreorderSearch, setDataPreorderSearch] = useState<PreOrderDetailsListResponse>();
    const pageSize = 25;

    const handlePageChange = (selectedPage: number) => {
        setCurrentPage(selectedPage);
    };
    //
    // const {data, isLoading, error} = useQuery({
    //     queryKey: ["preOrderDetails", preOrderId, currentPage + 1, pageSize],
    //     queryFn: fetchPreOrderWithDetails,
    // });

    const {data: dataPreOrder, isLoading: isLoadingPreOrder, error: errorPreOrder} = useQuery({
        queryKey: ["preOrderId", preOrderId],
        queryFn: fetchPreOrder,
    });

    useEffect(() => {
       
            const updatePreorderDetails = async () => {
                try {
                    let response;
                    
                    response = await
                            ApiHttpClient().post<PreOrderDetailsListResponse>(`/preOrderDetail/search`, {
                                advancedFilter: 
                                    { field: "PreOrderId", operator: "eq", value: Number(preOrderId) }
                                ,
                                pageNumber: currentPage + 1,
                                pageSize: pageSize
                            });

                    if (!response?.data) {
                        toast({description: "A aparut o eroare pentru afisarea articolelor din acest preoder"});
                        return <></>;
                    }
                    setDataPreorderSearch(response.data);
                } catch (error: any) {
                    if (error.name === 'AbortError') {
                        // Cererea a fost anulată — nu e eroare reală
                        return;
                    }
                    console.error(error);
                    toast({description: "A aparut o eroare la incarcarea datelor"});
                }
            }

        updatePreorderDetails();
    }, [preOrderId, currentPage, pageSize]);

    useEffect(() => {
        setInputValue(currentPage + 1);
    }, [currentPage]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = Number(e.target.value);

        if (dataPreorderSearch?.totalPages && value > dataPreorderSearch.totalPages) {
            value = dataPreorderSearch.totalPages;
        } else if (value < 1) {
            value = 1;
        }
        setInputValue(value);

        if (debounceTimer) clearTimeout(debounceTimer);

        const timer = setTimeout(() => {
            if (dataPreorderSearch?.totalPages && value >= 1 && value <= dataPreorderSearch?.totalPages) {
                handlePageChange(value - 1);
            }
        }, 500);

        setDebounceTimer(timer);
    };
    
    // const {data: dataOrders, isLoading: isLoadingOrders, error: errorOrders} = useQuery({
    //     queryKey: ["orders", preOrderId, currentPage + 1, pageSizeDataOrders],
    //     queryFn: fetchOrdersForPreOrder,
    // });

    if (isLoadingPreOrder) return <p
        className="h-screen w-screen flex items-center justify-center"><LoadingElement/></p>;
    if (preOrderId === undefined) return <p>A aparut o eroare la extragerea datelor despre comenzi.</p>;

    if (errorPreOrder || !dataPreOrder) {
        toast({description: "Exista o eroare la preluarea informatiilor despre aceasta precomanda."});
        return <></>;
    }

    // const handleDownloadInvoice = async () => {
    //     try {
    //         const response = await ApiHttpClient().get(`/invoice/pdf/${preOrderId}?businessType=Franchise`);

    //         if (response.status === 200) {

    //             for (var invoice of response.data.invoices) {
    //                 const { pdfBytes, fileName } = invoice;
    //                 // Decode the base64 string
    //                 const byteCharacters = atob(pdfBytes);
    //                 const byteNumbers = new Array(byteCharacters.length);
    //                 for (let i = 0; i < byteCharacters.length; i++) {
    //                     byteNumbers[i] = byteCharacters.charCodeAt(i);
    //                 }
    //                 const byteArray = new Uint8Array(byteNumbers);

    //                 // Create a Blob from the byteArray
    //                 const blob = new Blob([byteArray], { type: 'application/pdf' });
    //                 const url = window.URL.createObjectURL(blob);
    //                 const link = document.createElement('a');
    //                 link.href = url;

    //                 link.setAttribute('download', fileName || 'Factura.pdf');
    //                 document.body.appendChild(link);
    //                 link.click();

    //                 if (link.parentNode) {
    //                     link.parentNode.removeChild(link);
    //                 }

    //             }


    //         } else {
    //             console.error('A aparut o eroare la descarcarea facturii, mesajul:', response.status);
    //         }
    //     } catch (error) {
    //         console.error('A aparut o eroare la descarcarea facturii', error);
    //     }
    // }

    return (
        <>
            <Navbar/>
            <div className="flex flex-row items-start">
                <SideMenu/>
                {/* Desktop Version */}
                <div className="flex-col flex-grow hidden md:block">
                    <div className="flow-root rounded-lg py-4 ml-8 mt-8 mb-8">
                        <dl className="flex flex-row flex-nowrap gap-3 -my-3 text-sm">
                            <div className="flex flex-col border w-1/3 border-gray-100">
                                <div className="grid grid-cols-1 gap-1 py-3 sm:grid-cols-3 sm:gap-4">
                                    <dt className="font-medium underline text-gray-900 ml-2 mr-12">Numar precomanda</dt>
                                    <dd className="text-gray-700 sm:col-span-2">{preOrderId}</dd>
                                </div>

                                <div className="grid grid-cols-1 gap-1 py-5 sm:grid-cols-3 sm:gap-4">
                                    <dt className="font-medium underline text-gray-900 ml-2">Tip Document</dt>
                                    <dd className="text-gray-700 sm:col-span-2">
                                    </dd>
                                    <dt className="font-medium text-gray-900 ml-2">Nume</dt>
                                    <dd className="text-gray-700 sm:col-span-2">
                                        {dataPreOrder?.documentType.documentTypeName}
                                    </dd>
                                    <dt className="font-medium text-gray-900 ml-2">Cod</dt>
                                    <dd className="text-gray-700 sm:col-span-2">
                                        {dataPreOrder?.documentType.documentTypeCode}
                                    </dd>
                                </div>

                                <div className="grid grid-cols-1 gap-1 py-5 sm:grid-cols-3 sm:gap-4">
                                    <dt className="font-medium underline text-gray-900 ml-2">Livrare</dt>
                                    <dd className="text-gray-700 sm:col-span-2">
                                    </dd>
                                    <dt className="font-medium text-gray-900 ml-2">Data de livrare</dt>
                                    <dd className="text-gray-700 sm:col-span-2">
                                        {dataPreOrder?.shipping && dataPreOrder?.shipping.deliveryDate ? dataPreOrder?.shipping.deliveryDate.split("T")[0] : '-'}
                                    </dd>
                                </div>
                            </div>
                            <div className="flex flex-col border w-1/3 border-gray-100">
                                <div className="grid grid-cols-1 gap-1 py-3 sm:grid-cols-3 sm:gap-4">
                                    <dt className="font-medium underline text-gray-900 ml-2">Companie</dt>
                                    <dd className="text-gray-700 sm:col-span-2">
                                    </dd>
                                    <dt className="font-medium text-gray-900 ml-2">Nume</dt>
                                    <dd className="text-gray-700 sm:col-span-2">
                                        {dataPreOrder?.workingPoint.workingPointName}
                                    </dd>
                                    <dt className="font-medium text-gray-900 ml-2">Email</dt>
                                    <dd className="text-gray-700 sm:col-span-2">
                                        {dataPreOrder?.workingPoint.workingPointEmail}
                                    </dd>
                                    <dt className="font-medium text-gray-900 ml-2">Adresa</dt>
                                    <dd className="text-gray-700 sm:col-span-2">
                                        {dataPreOrder?.workingPoint.address ? dataPreOrder?.workingPoint.address.country &&
                                            <span>, </span> && dataPreOrder?.workingPoint.address.street &&
                                            <span>, </span> && dataPreOrder?.workingPoint.address.number : '-'}
                                    </dd>
                                </div>

                                <div className="grid grid-cols-1 gap-1 py-3 sm:grid-cols-3 sm:gap-4">
                                    <dt className="font-medium underline text-gray-900 ml-2 mr-12">Status precomanda</dt>
                                    <dd className="text-gray-700 sm:col-span-2">{dataPreOrder?.documentStatus.documentStatusName}</dd>
                                </div>

                                <div className="grid grid-cols-1 gap-1 py-3 sm:grid-cols-3 sm:gap-4">
                                    <dt className="font-medium underline text-gray-900 ml-2">Total precomanda</dt>
                                    <dd className="text-gray-700 sm:col-span-2">{dataPreOrder?.totalValue} RON</dd>
                                </div>
                            </div>
                        </dl>
                    </div>

                    <div className="flex-initial w-1/4 overflow-x-auto ml-8 mb-2 shadow-md sm:w-4/5 sm:rounded-lg">
                        <section>
                            <div className="max-w-[1320px] m-auto px-4 mt-1 py-0 sm:px-6 sm:py-2 lg:px-8">
                                <Table>
                                    <TableCaption></TableCaption>
                                    <TableHeader>
                                        <TableRow className="bg-white border-slate-200 mb-1">
                                            <TableHead className="text-nowrap">Cod articol</TableHead>
                                            <TableHead
                                                className="sticky left-0 bg-white z-10 w-[100px] text-nowrap">Denumire <br/> articol</TableHead>
                                            <TableHead className="text-center">Unitatea de vanzare</TableHead>
                                            <TableHead className="text-center">Pret pe bucata <span
                                                className="text-blue-900">fara TVA</span></TableHead>
                                            {/* <TableHead className="text-center">Pret unitar pe unitate de vanzare <span className="text-blue-900">fara TVA</span></TableHead>
                                            <TableHead className="text-center">Pret unitar pe unitate de vanzare cu <span className="text-blue-900">TVA inclus</span></TableHead> */}
                                            <TableHead className="text-center">Cantitate comandata</TableHead>
                                            <TableHead className="text-center">Cantitate livrata</TableHead>
                                            <TableHead className="text-center">Cantitate facturata</TableHead>
                                            <TableHead className="text-center">Total <div className="text-blue-900">fara
                                                TVA</div></TableHead>
                                            <TableHead className="text-center">Total <div className="text-blue-900">TVA
                                                inclus</div></TableHead>
                                            <TableHead className="text-center">Cantitate pregatita</TableHead>
                                        </TableRow>
                                    </TableHeader>
                                    <TableBody>
                                        {dataPreorderSearch && dataPreorderSearch?.items?.length > 0 && dataPreorderSearch?.items.map((orderDetail: PreOrderDetailsModel, index: number) => {
                                            let product = orderDetail.article as ArticleModel;

                                            return (
                                                <TableRow key={product.id}
                                                          className={index % 2 === 0 ? "bg-slate-150" : "bg-slate-100"}>
                                                    <TableCell>{product.id}</TableCell>
                                                    <TableCell
                                                        className={index % 2 === 0 ? "bg-white sticky left-0 z-10 font-medium w-[150px]" : "bg-slate-100 sticky left-0 z-10 font-medium w-[100px]"}>
                                                        <a href={"/product/" + product.id}
                                                           className="group relative block overflow-hidden text-left"
                                                        >{product.longName}</a>

                                                    </TableCell>
                                                    <TableCell
                                                        className="text-center text-nowrap">{product.salesUnit === 'A' &&
                                                        <p>Bucata</p>} {product.salesUnit === 'K' &&
                                                        <p>Kilogram</p>} {product.salesUnit === 'M' &&
                                                        <p>Metru</p>}</TableCell>
                                                    <TableCell
                                                        className="text-center text-nowrap">{orderDetail.salesPrice} RON</TableCell>
                                                    <TableCell
                                                        className="text-center text-nowrap">{orderDetail.quantity}</TableCell>
                                                    <TableCell
                                                        className="text-center text-nowrap">{orderDetail.shippedQuantity ? orderDetail.shippedQuantity : '-'}</TableCell>
                                                    <TableCell
                                                        className="text-center text-nowrap">{orderDetail.invoicedQuantity ? orderDetail.invoicedQuantity : '-'}</TableCell>
                                                    <TableCell
                                                        className="text-center text-nowrap">{orderDetail.totalValueWithoutVAT} RON</TableCell>
                                                    <TableCell
                                                        className="text-center text-nowrap">{orderDetail.totalValue} RON</TableCell>
                                                    <TableCell
                                                        className="text-center text-nowrap">{orderDetail.fulfilledPercent ? orderDetail.fulfilledPercent + "%" : "-"}</TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </div>
                        </section>
                        <div className="text-center mt-8 mb-2">
                            <ul className="flex justify-center gap-1 text-gray-900 mt-3">
                                <li>
                                    <button
                                        onClick={(e) => {
                                            e.preventDefault();
                                            if (currentPage > 0) handlePageChange(currentPage - 1);
                                        }}
                                        className="grid mr-2 size-8 place-content-center rounded border border-gray-200 transition-colors hover:bg-gray-50 rtl:rotate-180"
                                        aria-label="Previous page"
                                        disabled={currentPage === 0}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="size-4"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    </button>
                                </li>

                                <li>
                                    <label htmlFor="Page" className="flex items-center gap-1">
                                        <span className="sr-only">Pagina</span>
                                        <input
                                            type="number"
                                            id="Page"
                                            value={inputValue}
                                            min={1}
                                            max={dataPreorderSearch?.totalPages}
                                            onChange={handleInputChange}
                                            className="h-8 w-10 rounded border-gray-300 text-center sm:text-sm"
                                        />
                                        <span className="text-sm">/ {dataPreorderSearch?.totalPages}</span>
                                    </label>
                                </li>

                                <li>
                                    <button
                                        onClick={(e) => {
                                            e.preventDefault();
                                            if (dataPreorderSearch && currentPage < dataPreorderSearch?.totalPages - 1) handlePageChange(currentPage + 1);
                                        }}
                                        className="grid ml-2 size-8 place-content-center rounded border border-gray-200 transition-colors hover:bg-gray-50 rtl:rotate-180"
                                        aria-label="Next page"
                                        disabled={dataPreorderSearch && currentPage === dataPreorderSearch.totalPages - 1}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="size-4"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Mobile Version */}
                <div className="relative mx-auto overflow-auto md:hidden ">
                    <div className="flow-root rounded-lg py-4 ml-2 mt-8 mb-2">
                        <dl className="flex flex-row flex-nowrap gap-3 -my-3 text-sm">
                            <div className="flex flex-col border w-auto border-gray-100">
                                <div className="grid py-3 w-auto grid-cols-3 gap-2">
                                    <dt className="font-medium underline text-gray-900 ml-2 mr-12">Numar precomanda</dt>
                                    <dd className="text-gray-700 col-span-2">{preOrderId}</dd>
                                </div>

                                <div className="grid py-3 w-auto grid-cols-3 gap-2">
                                    <dt className="font-medium underline text-gray-900 ml-2">Tip Document</dt>
                                    <dd className="text-gray-700 col-span-2">
                                    </dd>
                                    <dt className="font-medium text-gray-900 ml-2">Nume</dt>
                                    <dd className="text-gray-700 col-span-2">
                                        {dataPreOrder?.documentType.documentTypeName}
                                    </dd>
                                    <dt className="font-medium text-gray-900 ml-2">Cod</dt>
                                    <dd className="text-gray-700 col-span-2">
                                        {dataPreOrder?.documentType.documentTypeCode}
                                    </dd>
                                </div>

                                <div className="grid py-3 w-auto grid-cols-3 gap-2">
                                    <dt className="font-medium underline text-gray-900 ml-2">Companie</dt>
                                    <dd className="text-gray-700 col-span-2">
                                    </dd>
                                    <dt className="font-medium text-gray-900 ml-2">Nume</dt>
                                    <dd className="text-gray-700 col-span-2">
                                        {dataPreOrder?.workingPoint.workingPointName}
                                    </dd>
                                    <dt className="font-medium text-gray-900 ml-2">Email</dt>
                                    <dd className="text-gray-700 col-span-2">
                                        {dataPreOrder?.workingPoint.workingPointEmail}
                                    </dd>
                                    <dt className="font-medium text-gray-900 ml-2">Adresa</dt>
                                    <dd className="text-gray-700 col-span-2">
                                        {dataPreOrder?.workingPoint.address ? dataPreOrder?.workingPoint.address.country &&
                                            <span>, </span> && dataPreOrder?.workingPoint.address.street &&
                                            <span>, </span> && dataPreOrder?.workingPoint.address.number : '-'}
                                    </dd>
                                </div>

                                <div className="grid py-3 w-auto grid-cols-3 gap-2">
                                    <dt className="font-medium underline text-gray-900 ml-2">Livrare</dt>
                                    <dd className="text-gray-700 col-span-2">
                                    </dd>
                                    <dt className="font-medium text-gray-900 ml-2">Data de livrare</dt>
                                    <dd className="text-gray-700 col-span-2">
                                        {dataPreOrder?.shipping && dataPreOrder?.shipping.deliveryDate ? dataPreOrder?.shipping.deliveryDate.split("T")[0] : '-'}
                                    </dd>
                                </div>
                                
                                <div className="grid py-3 w-auto grid-cols-3 gap-2">
                                    <dt className="font-medium underline text-gray-900 ml-2 mr-12">Status precomanda</dt>
                                    <dd className="text-gray-700 col-span-2">{dataPreOrder?.documentStatus.documentStatusName}</dd>
                                </div>

                                <div className="grid py-3 w-auto grid-cols-3 gap-2">
                                    <dt className="font-medium underline text-gray-900 ml-2">Total precomanda</dt>
                                    <dd className="text-gray-700 sm:col-span-2">{dataPreOrder?.totalValue} RON</dd>
                                </div>
                            </div>
                        </dl>
                    </div>

                    <div className="flex-initial ml-2 mb-2 shadow-md w-7/8 rounded-lg">
                        <div className="overflow-auto" style={{maxHeight: "600px"}}>
                            
                            <section>
                                <div className="max-w-[1320px] m-auto px-4 mt-1 py-0 sm:px-6 sm:py-2 lg:px-8">
                                    <Table>
                                        <TableCaption></TableCaption>
                                        <TableHeader>
                                            <TableRow className="bg-white border-slate-200 mb-1">
                                                <TableHead className="text-nowrap">Cod articol</TableHead>
                                                <TableHead
                                                    className="sticky left-0 bg-white z-10 w-[100px] text-nowrap">Denumire <br/> articol</TableHead>
                                                <TableHead className="text-center">Unitatea de vanzare</TableHead>
                                                <TableHead className="text-center">Pret pe bucata <span
                                                    className="text-blue-900">fara TVA</span></TableHead>
                                                {/* <TableHead className="text-center">Pret unitar pe unitate de vanzare <span className="text-blue-900">fara TVA</span></TableHead>
                                            <TableHead className="text-center">Pret unitar pe unitate de vanzare cu <span className="text-blue-900">TVA inclus</span></TableHead> */}
                                                <TableHead className="text-center">Cantitate comandata</TableHead>
                                                <TableHead className="text-center">Cantitate livrata</TableHead>
                                                <TableHead className="text-center">Cantitate facturata</TableHead>
                                                <TableHead className="text-center">Total <div
                                                    className="text-blue-900">fara TVA</div></TableHead>
                                                <TableHead className="text-center">Total <div
                                                    className="text-blue-900">TVA inclus</div></TableHead>
                                                <TableHead className="text-center">Cantitate pregatita</TableHead>
                                            </TableRow>
                                        </TableHeader>
                                        <TableBody>
                                            {dataPreorderSearch && dataPreorderSearch?.items?.length > 0 && dataPreorderSearch?.items.map((orderDetail: PreOrderDetailsModel, index: number) => {
                                                let product = orderDetail.article as ArticleModel;

                                                return (
                                                    <TableRow key={product.id}
                                                              className={index % 2 === 0 ? "bg-slate-150" : "bg-slate-100"}>
                                                        <TableCell>{product.id}</TableCell>
                                                        <TableCell
                                                            className={index % 2 === 0 ? "bg-white sticky left-0 z-10 font-medium w-[150px]" : "bg-slate-100 sticky left-0 z-10 font-medium w-[100px]"}>
                                                            <a href={"/product/" + product.id}
                                                               className="group relative block overflow-hidden text-left"
                                                            >{product.longName}</a>

                                                        </TableCell>
                                                        <TableCell
                                                            className="text-center text-nowrap">{product.salesUnit === 'A' &&
                                                            <p>Bucata</p>} {product.salesUnit === 'K' &&
                                                            <p>Kilogram</p>} {product.salesUnit === 'M' &&
                                                            <p>Metru</p>}</TableCell>
                                                        <TableCell
                                                            className="text-center text-nowrap">{orderDetail.salesPrice} RON</TableCell>
                                                        <TableCell
                                                            className="text-center text-nowrap">{orderDetail.quantity}</TableCell>
                                                        <TableCell
                                                            className="text-center text-nowrap">{orderDetail.shippedQuantity ? orderDetail.shippedQuantity : '-'}</TableCell>
                                                        <TableCell
                                                            className="text-center text-nowrap">{orderDetail.invoicedQuantity ? orderDetail.invoicedQuantity : '-'}</TableCell>
                                                        <TableCell
                                                            className="text-center text-nowrap"> {orderDetail.totalValueWithoutVAT} RON</TableCell>
                                                        <TableCell
                                                            className="text-center text-nowrap"> {orderDetail.totalValue} RON</TableCell>
                                                        <TableCell
                                                            className="text-center text-nowrap">{orderDetail.fulfilledPercent ? orderDetail.fulfilledPercent + "%" : "-"}</TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                        </TableBody>
                                    </Table>
                                </div>

                            </section>
                            <div className="text-center mt-8 mb-2">
                                <ul className="flex justify-center gap-1 text-gray-900 mt-3">
                                    <li>
                                        <button
                                            onClick={(e) => {
                                                e.preventDefault();
                                                if (currentPage > 0) handlePageChange(currentPage - 1);
                                            }}
                                            className="grid mr-2 size-8 place-content-center rounded border border-gray-200 transition-colors hover:bg-gray-50 rtl:rotate-180"
                                            aria-label="Previous page"
                                            disabled={currentPage === 0}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="size-4"
                                                viewBox="0 0 20 20"
                                                fill="currentColor"
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                                                    clipRule="evenodd"
                                                />
                                            </svg>
                                        </button>
                                    </li>

                                    <li>
                                        <label htmlFor="Page" className="flex items-center gap-1">
                                            <span className="sr-only">Pagina</span>
                                            <input
                                                type="number"
                                                id="Page"
                                                value={inputValue}
                                                min={1}
                                                max={dataPreorderSearch?.totalPages}
                                                onChange={handleInputChange}
                                                className="h-8 w-10 rounded border-gray-300 text-center sm:text-sm"
                                            />
                                            <span className="text-sm">/ {dataPreorderSearch?.totalPages}</span>
                                        </label>
                                    </li>

                                    <li>
                                        <button
                                            onClick={(e) => {
                                                e.preventDefault();
                                                if (dataPreorderSearch && currentPage < dataPreorderSearch.totalPages - 1) handlePageChange(currentPage + 1);
                                            }}
                                            className="grid ml-2 size-8 place-content-center rounded border border-gray-200 transition-colors hover:bg-gray-50 rtl:rotate-180"
                                            aria-label="Next page"
                                            disabled={dataPreorderSearch && currentPage === dataPreorderSearch.totalPages - 1}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="size-4"
                                                viewBox="0 0 20 20"
                                                fill="currentColor"
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                                    clipRule="evenodd"
                                                />
                                            </svg>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default MyPreOrderDetails;